<template>
  <div>
    <review stage="4" auditType="2" />
  </div>
</template>

<script>
  import review from './review'
  export default {
    name: "auditHistory",
    components:{review},
  }
</script>